module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/calendar-a77b4c50fb4eb509a53d0e5fa3545af2.png";